<template>
	<div id="app">
		<router-view @login="loginDirect"></router-view>
	</div>
</template>

<script>
import { session, deepcopy } from '@/util'
import store from '@/stores';
import { GENERATEROUTES, USERINFO, REFRESH, LOGOUT, LOCAL_TOKEN } from '@/stores/types';
import Api from '@/api'
import routeMap, { home } from '@/routes/route_map'
import { baseRoute } from '@/routes'

const signIn = function (callback) {
	let self = this;
	// 检查登录状态
	let local = session('token');
	let user = session('user');

	if (!local && !user) {
		if (baseRoute.every(route => window.location.href.indexOf(route.path) == -1)) {
			return self.$router.push({ path: '/logining', query: { from: self.$router.currentRoute.fullPath } })
		}
	} else {
		this.$store.dispatch(REFRESH)
	}
	// 获取用户信息及权限数据

	if (user) {
		this.$store.dispatch(GENERATEROUTES, { unitid: user.zgRoleCode }).then((menus) => { // 生成可访问的路由表
			menus.splice(0, 0, home)
			// 动态注入路由
			self.extendRoutes(menus);
			//执行回调
			typeof callback === 'function' && callback();
		});
	}

}

const extendRoutes = function (allowedRouter) {
	let vm = this;
	let actualRouter = deepcopy(allowedRouter) //.slice(0);
	actualRouter.map(e => {
		//为动态路由添加独享守卫
		return e.beforeEnter = function (to, from, next) {
			next()
		}
	});
	let originPath = deepcopy(routeMap)// routeMap.slice(0);

	originPath[0].children = actualRouter;

	vm.$router.addRoutes(originPath.concat([{
		path: '*',
		redirect: '/404'
	}]));
}
export let sign = {
	methods: {
		signIn,
		extendRoutes
	}
}
export default {
	name: 'app',
	mixins: [sign],
	data() {
		return {
			menuData: null,
			userData: null
		}
	},
	methods: {
		// 登录重定向
		loginDirect(newPath, loginObj) {
			this.signIn(() => {
				loginObj.loading = false;
				this.$router.replace({ path: newPath || '/' });
			});
		}
	},
	created() {
		this.signIn();
		document.addEventListener('click', function (event) {
			let haveClassName = (target, className) => {
				var _classNAMELIST = target.className && target.className.trim().replace(/\\s+/, ' ').split(' ');
				return _classNAMELIST && _classNAMELIST.includes(className);
			}
			var target = event.target;
			var input = target.parentNode;
			if (!haveClassName(target, 'wcyc-combotree-panel')) {
				let elments = document.getElementsByClassName('wcyc-combotree-panel');
				if (haveClassName(input, 'wcyc-combotree')) {
					input.nextElementSibling.style.display = input.nextElementSibling.style.display === 'none' ? '' : 'none';
				} else {
					for (const element of elments) {
						element.style.display = 'none'
					}
				}
			}
		})

	}
}
</script>
<style>
#app {
	width: 100%;
	min-width: 1200px;
	min-height: 100%;
	background: #f0f0f0;
}
</style>




// WEBPACK FOOTER //
// src/App.vue